<template>
  <a
    v-bind="$attrs"
    v-on="$listeners"
    class="jade-link"
    :class="computedClass"
    role="link"
  >
    <jade-icon
      v-if="icon"
      :use="icon"
      aria-hidden
      size="small"
      :color="computedIconColor"
    />

    <jade-text
      weight="medium"
      :variant="computedText"
      color="current-color"
    >
      <slot></slot>
    </jade-text>

    <jade-icon
      v-if="external"
      aria-hidden
      use="arrow-north-east"
      size="small"
      :color="computedIconColor"
      data-testid="external-icon"
    />
    <jade-icon
      v-else
      aria-hidden
      use="chevron-right"
      size="small"
      :color="computedIconColor"
    />
  </a>
</template>

<script>
import JadeText from '../JadeText/index.vue'
import JadeIcon from '../JadeIcon/index.vue'
import SIZE_ENUM from '../enums/sizes.enum'
import COLOR_ENUM from '../enums/colors.enum'

const VARIANTS = [
  COLOR_ENUM.WARNING,
  COLOR_ENUM.ON_BRAND,
  COLOR_ENUM.NEGATIVE,
  COLOR_ENUM.ON_COLOR,
  COLOR_ENUM.BRAND,
  COLOR_ENUM.POSITIVE,
  COLOR_ENUM.INFO,
  COLOR_ENUM.NEUTRAL
]

export default {
  name: 'JadeLink',

  components: {
    JadeText,
    JadeIcon
  },

  props: {
    external: Boolean,
    icon: String,
    size: {
      type: String,
      validation: size => [SIZE_ENUM.LARGE, SIZE_ENUM.MEDIUM].includes(size),
      default: SIZE_ENUM.MEDIUM
    },
    variant: {
      type: String,
      validation: variant => VARIANTS.includes(variant),
      default: COLOR_ENUM.BRAND
    }
  },

  computed: {
    computedClass () {
      return {
        [`is-${this.variant}`]: this.variant
      }
    },
    computedText () {
      return `text-${this.size}`
    },
    computedIconColor () {
      return this.variant === COLOR_ENUM.NEUTRAL
        ? COLOR_ENUM.HIGH
        : this.variant
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/link.css';
</style>
